import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';


/**
 * @deprecated
 * Please, use confirmation-dialog instead
 */


@Component({
    selector: 'app-confirmation-popup',
    templateUrl: './confirmation-popup.component.html',
    styleUrls: ['./confirmation-popup.component.scss'],
    standalone: false
})
export class ConfirmationPopupComponent implements OnInit {
  
  @Input() text;
	public onConfirm: Subject<boolean>;

  constructor(
		public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.onConfirm = new Subject();
  }

  public confirm(event) {
		this.bsModalRef.hide();
		this.onConfirm.next(true);
  }

  public close(event) {
		this.bsModalRef.hide();
  }
}